import React from "react";
import { MDBRow, MDBCol, MDBIcon } from "mdbreact";
import { BrowserRouter as Router, Link as RouterLink } from "react-router-dom";
import Link from "@material-ui/core/Link";
import _ from "lodash";
import ArrowBack from "@material-ui/icons/ArrowBack";
import CircularProgress from "@material-ui/core/CircularProgress";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import {
    MDBCard,
    MDBCardBody,
    MDBCardText,
} from "mdb-react-ui-kit";
import { withUserContext } from "../../../contexts/UserContext";
import SearchSelectField from "../../SharedComponents/SearchSelectField";
import BasicButton from "../../SharedComponents/BasicButton/BasicButton";
import SelectField from "../../SharedComponents/SelectField/SelectField";
import BasicTextArea from "../../SharedComponents/BasicTextArea/BasicTextArea";
import TableComponent from "../../SharedComponents/Table";
import "./PODetails.scss";
import {
    optionalRightsConfigTenant3,
    NewPOHeader,
    NewPOLine,
} from "./config";
import PostWatchService from "../../../services/service";
import * as Constants from "../../../constants/constants";
import Popover from "@material-ui/core/Popover";
import axios from "axios";
import Modal from "../../SharedComponents/Modal/Modal";
import BasicTextField from "../../SharedComponents/BasicTextField/BasicTextField";
import DateField from "../../SharedComponents/DateField/DateField";
import NotificationComponent from "../../../Common/NotificationComponent/NotificationComponent"
import CreatePO from "../../CreatePO/CreatePO";
import RichTextEditor from "../../SharedComponents/RichTextEditor/RichTextEditor";
import { getFormattedDate, isValidYYYYMMDD } from '../../../Common/Helper';
import moment from 'moment-timezone';

let PONo,defaultCostCenter=null;
class PODetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            poLinesList: null,
            isFetchingPOLines: false,
            poHeaders: null,
            NewPOHeader: { ...NewPOHeader },
            isFetchingCurrencies: false,
            isFetchingPoHeaders: false,
            searchCancelToken: null,
            selectedVendor: null,
            selectedRequestedByUser: null,
            selectedIssuedByUser: null,
            selectedApprovedByUser: null,
            selectedDeptHeadUser: null,
            vendorsList: null,
            selectedVendorLocation: null,
            selectedVendorLocationList: null,
            postInitiated: false,
            anchorEl: null,
            openPopover: false,
            selectedNoteRow: null,
            selectedNoteMessage: null,
            poRangeData: null,
            poErrormsg: false,
            activPORangeList: null,
            selectedTemplate: null,
            selectedTemplatePONumber: null,
            isFetchingShowReport: false,
            showCopyPoModal: false,
            reportData: null,
            defaultCompanyCurrency: null,
            subtotalCost: null,
            remainingCost: null,
            editPoet1: false,
            selectedVendorContact: null,
            selectedVendorContactList: [],
            vendorExpand: false,
            shipToExpand: false,
            billToExpand: false,
            shipToVendorsList: null,
            selectedShipToVendor: null,
            selectedShipToVendorLocation: null,
            selectedShipToVendorLocationList: null,
            selectedShipToVendorContact: null,
            selectedShipToVendorContactList: [],
            selectedBillToVendor: null,
            selectedBillToVendorLocation: null,
            selectedBillToVendorLocationList: null,
            selectedBillToVendorContact: null,
            selectedBillToVendorContactList: [],
            clearVendor: false,
            clearShipTo: false,
            poSuccess: false,
            savedVendor: false,
            lastSavedVendor: [],
            lastSavedShipTo: [],
            requestedByOptions: [],
            unitOptions: [],
            costCenterOptions: [],
            newPOCostCenter : {}
        };
    }
    getAllCostCenters = () => {
        PostWatchService.getData(
            Constants.postWatchServiceBaseUrl +
            `/getlookupdata?objectType=costcenter`,
            this.props?.userContext?.active_tenant?.tenant_id
        ).then(
            (response) => {
                let poHeadersTemp = JSON.parse(JSON.stringify(this.state.poHeaders));
                if (!poHeadersTemp?.cost_center_no && response.data?.results?.length > 0) {
                    defaultCostCenter = response.data?.results?.filter((item, index) => item?.lookup_code === "default")?.[0];
                    poHeadersTemp.cost_center_id = defaultCostCenter?.lookup_data_id;
                    poHeadersTemp.cost_center_no = defaultCostCenter?.lookup_value;
                }
                this.setState({
                    costCenterOptions: response.data?.results?.length>0 ? response.data?.results?.filter(item => item?.is_active===1) : [],
                    poHeaders: poHeadersTemp
                });
            },
            (err) => { }
        );
    }
    componentDidMount() {
        // -1 for New PO creation
        if (this.props?.poOrder === -1) {
            let poHeaderNew = { ...NewPOHeader };
            poHeaderNew.show_season_id = this.props?.selectedSeason?.show_season_id;
            poHeaderNew.episode_id = this.props?.selectedEpisode?.episode_id;
            poHeaderNew.po_prefix = this.props?.preFix;
            poHeaderNew["date_ordered"] = new Date().toLocaleDateString('en-CA');
            poHeaderNew["modified_date"] = new Date().toLocaleDateString('en-CA');
            poHeaderNew["issue_date"] = new Date().toLocaleDateString('en-CA');
            poHeaderNew["issued_by_id"] = this.props?.userContext?.user_profile?.user_id;
            poHeaderNew["issued_by_name"] = this.props?.userContext?.user_profile?.full_name;
            poHeaderNew["ship_to_name"] = this.props?.initialShipToVendor?.length > 0 ? this.props?.initialShipToVendor?.[0]?.vendor_name : null;
            poHeaderNew["ship_to_id"] = this.props?.initialShipToVendor?.length > 0 ? this.props?.initialShipToVendor?.[0]?.vendor_id : null;
            poHeaderNew["ship_to_locations"] = this.props?.initialShipToVendor?.length > 0 ? this.props?.initialShipToVendor?.[0]?.vendor_locations?.length > 0 ? this.props?.initialShipToVendor?.[0]?.vendor_locations : [] : [];
            poHeaderNew["ship_to_contacts"] = this.props?.initialShipToVendor?.length > 0 ? this.props?.initialShipToVendor?.[0]?.vendor_contacts?.length > 0 ? this.props?.initialShipToVendor?.[0]?.vendor_contacts : [] : [];
            let selectedShipToVendorLocation = this.props?.initialShipToVendor?.length > 0 ? this.props?.initialShipToVendor?.[0]?.vendor_locations?.length > 0 ? this.props?.initialShipToVendor?.[0]?.vendor_locations?.[0] : null : null;
            let selectedShipToVendorContact = this.props?.initialShipToVendor?.length > 0 ? this.props?.initialShipToVendor?.[0]?.vendor_contacts?.length > 0 ? this.props?.initialShipToVendor?.[0]?.vendor_contacts?.[0] : null : null;
            poHeaderNew["po_ship_to_contact_id"] = this.props?.initialShipToVendor?.length > 0 ? this.props?.initialShipToVendor?.[0]?.vendor_contacts?.length > 0 ? this.props?.initialShipToVendor?.[0]?.vendor_contacts?.[0]?.vendor_contact_id : null : null;
            poHeaderNew["po_ship_to_location_id"] = this.props?.initialShipToVendor?.length > 0 ? this.props?.initialShipToVendor?.[0]?.vendor_locations?.length > 0 ? this.props?.initialShipToVendor?.[0]?.vendor_locations?.[0]?.vendor_location_id : null : null;
            poHeaderNew["bill_to_name"] = this.props?.initialBillToVendor?.length > 0 ? this.props?.initialBillToVendor?.[0]?.vendor_name : null;
            poHeaderNew["bill_to_id"] = this.props?.initialBillToVendor?.length > 0 ? this.props?.initialBillToVendor?.[0]?.vendor_id : null;
            poHeaderNew["bill_to_locations"] = this.props?.initialBillToVendor?.length > 0 ? this.props?.initialBillToVendor?.[0]?.vendor_locations?.length > 0 ? this.props?.initialBillToVendor?.[0]?.vendor_locations : [] : [];
            poHeaderNew["bill_to_contacts"] = this.props?.initialBillToVendor?.length > 0 ? this.props?.initialBillToVendor?.[0]?.vendor_contacts?.length > 0 ? this.props?.initialBillToVendor?.[0]?.vendor_contacts : [] : [];
            let selectedBillToVendorLocation = this.props?.initialBillToVendor?.length > 0 ? this.props?.initialBillToVendor?.[0]?.vendor_locations?.length > 0 ? this.props?.initialBillToVendor?.[0]?.vendor_locations?.[0] : null : null;
            let selectedBillToVendorContact = this.props?.initialBillToVendor?.length > 0 ? this.props?.initialBillToVendor?.[0]?.vendor_contacts?.length > 0 ? this.props?.initialBillToVendor?.[0]?.vendor_contacts?.[0] : null : null;
            poHeaderNew["po_bill_to_contact_id"] = this.props?.initialBillToVendor?.length > 0 ? this.props?.initialBillToVendor?.[0]?.vendor_contacts?.length > 0 ? this.props?.initialBillToVendor?.[0]?.vendor_contacts?.[0]?.vendor_contact_id : null : null;
            poHeaderNew["po_bill_to_location_id"] = this.props?.initialBillToVendor?.length > 0 ? this.props?.initialBillToVendor?.[0]?.vendor_locations?.length > 0 ? this.props?.initialBillToVendor?.[0]?.vendor_locations?.[0]?.vendor_location_id : null : null;
            poHeaderNew["bill_to_attn"] = null;
            poHeaderNew["ship_to_attn"] = null;
            this.setState({
                poHeaders: poHeaderNew,
                selectedIssuedByUser: {
                    user_id: this.props?.userContext?.user_profile?.user_id,
                    user_name: this.props?.userContext?.user_profile?.full_name
                },
                lastSavedShipTo: {
                    vendor_name: poHeaderNew?.ship_to_name,
                    vendor_id: poHeaderNew?.ship_to_id,
                    vendor_locations: poHeaderNew?.ship_to_locations,
                    vendor_contacts: poHeaderNew?.ship_to_contacts,
                    po_ship_to_contact_id: poHeaderNew["po_ship_to_contact_id"],
                    po_ship_to_location_id: poHeaderNew["po_ship_to_location_id"],
                },

                selectedShipToVendor: {
                    vendor_name: poHeaderNew?.ship_to_name,
                    vendor_id: poHeaderNew?.ship_to_id,
                    vendor_locations: poHeaderNew?.ship_to_locations,
                    vendor_contacts: poHeaderNew?.ship_to_contacts,
                },
                selectedShipToVendorLocationList: poHeaderNew?.ship_to_locations,
                selectedShipToVendorLocation,
                selectedShipToVendorContact,
                selectedShipToVendorContactList: poHeaderNew?.ship_to_contacts,
                lastSavedBillTo: {
                    vendor_name: poHeaderNew?.bill_to_name,
                    vendor_id: poHeaderNew?.bill_to_id,
                    vendor_locations: poHeaderNew?.bill_to_locations,
                    vendor_contacts: poHeaderNew?.bill_to_contacts,
                    po_bill_to_contact_id: poHeaderNew["po_bill_to_contact_id"],
                    po_bill_to_location_id: poHeaderNew["po_bill_to_location_id"],
                },
                selectedBillToVendor: {
                    vendor_name: poHeaderNew?.bill_to_name,
                    vendor_id: poHeaderNew?.bill_to_id,
                    vendor_locations: poHeaderNew?.bill_to_locations,
                    vendor_contacts: poHeaderNew?.bill_to_contacts,
                },
                selectedBillToVendorLocationList: poHeaderNew?.bill_to_locations,
                selectedBillToVendorLocation,
                selectedBillToVendorContact: this.setBillToVendorContact(),
                selectedBillToVendorContactList: poHeaderNew?.bill_to_contacts,
            }, () => {
                this.getUnit();
                this.getAllCostCenters();
            });
        } else {
            this.getPOLines(this.props?.poOrder?.po_id);
            // If in PO is void then we dont have to show edit and delete icons
            if (this.props?.poOrder?.is_void === 1) {
                optionalRightsConfigTenant3.actions = ["", "file", "info-circle", "", ""];
            } else {
                optionalRightsConfigTenant3.actions = ["copy", "file", "info-circle", "pen", "trash-alt"];
            }
            let selectedVendorLocation = _.find(
                this.props?.poOrder?.vendor_locations,
                { vendor_location_id: this.props?.poOrder?.po_vendor_location_id }
            );
            let selectedShipToVendorLocation = _.find(
                this.props?.poOrder?.ship_to_locations,
                { vendor_location_id: this.props?.poOrder?.po_ship_to_location_id }
            );
            let selectedBillToVendorLocation = _.find(
                this.props?.poOrder?.bill_to_locations,
                { vendor_location_id: this.props?.poOrder?.po_bill_to_location_id }
            );
            let tempPoHeaders = { ...this.props?.poOrder };
            if(window?.location?.href?.includes('isCopyPo')){
                tempPoHeaders["modified_date"] = new Date().toLocaleDateString('en-CA');
            }
            this.setState({ poHeaders: tempPoHeaders, backupPoHeaders: tempPoHeaders }, () => {
                this.getUnit();
                this.getAllCostCenters();
                this.setState({
                    lastSavedVendor: {
                        vendor_name: this.state.poHeaders?.vendor_name,
                        vendor_id: this.state.poHeaders?.vendor_id,
                        vendor_locations: this.state.poHeaders?.vendor_locations,
                        vendor_contacts: this.state.poHeaders?.vendor_contacts,
                        po_vendor_location_id: this.state.poHeaders?.po_vendor_location_id,
                        po_vendor_contact_id: this.state.poHeaders?.po_vendor_contact_id
                    },
                    lastSavedShipTo: {
                        vendor_name: this.state.poHeaders?.ship_to_name,
                        vendor_id: this.state.poHeaders?.ship_to_id,
                        vendor_locations: this.state.poHeaders?.ship_to_locations,
                        vendor_contacts: this.state.poHeaders?.ship_to_contacts,
                    },
                    selectedVendor: {
                        vendor_name: this.state.poHeaders?.vendor_name,
                        vendor_id: this.state.poHeaders?.vendor_id,
                        vendor_locations: this.state.poHeaders?.vendor_locations,
                        vendor_contacts: this.state.poHeaders?.vendor_contacts,
                    },
                    selectedRequestedByUser: {
                        user_id: this.state.poHeaders?.requested_by_id,
                        user_name: this.state.poHeaders?.requested_by_name,
                    },
                    selectedIssuedByUser: {
                        user_id: this.state.poHeaders?.issued_by_id,
                        user_name: this.state.poHeaders?.issued_by_name,
                    },
                    selectedApprovedByUser: {
                        user_id: this.state.poHeaders?.approver_id,
                        user_name: this.state.poHeaders?.approver_name,
                    },
                    selectedDeptHeadUser: {
                        user_id: this.state.poHeaders?.department_head_id,
                        user_name: this.state.poHeaders?.department_head_name,
                    },
                    selectedBillToVendor: {
                        vendor_name: this.state.poHeaders?.bill_to_name,
                        vendor_id: this.state.poHeaders?.bill_to_id,
                        vendor_locations: this.state.poHeaders?.bill_to_locations,
                        vendor_contacts: this.state.poHeaders?.bill_to_contacts,
                    },
                    selectedShipToVendor: {
                        vendor_name: this.state.poHeaders?.ship_to_name,
                        vendor_id: this.state.poHeaders?.ship_to_id,
                        vendor_locations: this.state.poHeaders?.ship_to_locations,
                        vendor_contacts: this.state.poHeaders?.ship_to_contacts,
                    },
                    selectedVendorLocationList: this.state.poHeaders?.vendor_locations,
                    selectedVendorLocation,
                    selectedVendorContact: this.setVendorContact(),
                    selectedVendorContactList: this.state.poHeaders?.vendor_contacts,
                    selectedShipToVendorLocationList: this.state.poHeaders?.ship_to_locations,
                    selectedBillToVendorLocationList: this.state.poHeaders?.bill_to_locations,
                    selectedShipToVendorLocation,
                    selectedBillToVendorLocation,
                    selectedShipToVendorContact: this.setShipToVendorContact(),
                    selectedBillToVendorContact: this.setBillToVendorContact(),
                    selectedShipToVendorContactList: this.state.poHeaders?.ship_to_contacts,
                    selectedBillToVendorContactList: this.state.poHeaders?.bill_to_contacts,
                });
            });

        }
        this.getMyVendors();
        this.props.userContext?.getPORange(
            this.props?.selectedSeason?.show_season_id,
            this.props?.userContext?.active_tenant?.tenant_id
        );
        this.props.userContext?.getTemplates(
            this.props.show_id,
            this.props.selectedSeason?.season_id,
            this.props?.userContext?.user_profile?.user_id
        );

    }

    setVendorContact() {
        return this.state.poHeaders?.vendor_contacts?.filter(contact => contact.vendor_contact_id === this.state.poHeaders?.po_vendor_contact_id)?.[0];
    }

    setShipToVendorContact() {
        return this.state.poHeaders?.ship_to_contacts?.filter(contact => contact.vendor_contact_id === this.state.poHeaders?.po_ship_to_contact_id)?.[0];
    }
    setBillToVendorContact() {
        return this.state.poHeaders?.bill_to_contacts?.filter(contact => contact.vendor_contact_id === this.state.poHeaders?.po_bill_to_contact_id)?.[0];

    }

    editPoet(count) {
        if (count == 1) {
            this.setState({ editPoet1: true });
        } else if (count == 0) {
            if(this.props?.poOrder === -1){
                let backupPoHeaders = JSON.parse(JSON.stringify(this.state.poHeaders))
                this.setState({ editPoet1: false, backupPoHeaders });

            }else{
                this.setState({ editPoet1: false });
            }
        }

    }
    clearCostCenterField = () => {
        if(this.props?.poOrder === -1){
            if(this.state.poHeaders["cost_center_id"] && !this.state?.backupPoHeaders?.["cost_center_id"]){
                this.onPoHeaderChange("cost_center_id", defaultCostCenter?.lookup_data_id);
                this.onPoHeaderChange("cost_center_no", defaultCostCenter?.lookup_value); 
                
            }else{
                this.onPoHeaderChange("cost_center_id", this.state.poHeaders["cost_center_id"]);
                this.onPoHeaderChange("cost_center_no", this.state.poHeaders["cost_center_no"]); 
            }
        }else{
            this.onPoHeaderChange("cost_center_id", this.state?.backupPoHeaders["cost_center_id"])
            this.onPoHeaderChange("cost_center_no", this.state?.backupPoHeaders["cost_center_no"]);
        }
        this.setState({ editPoet1: false });
    }

    showVendorContactDetail = () => {
        const { selectedVendorContact } = this.state;

        return (
            <div>
                {selectedVendorContact?.contact_name && (
                    <div className="f-65rem"><span className="c-black f-75rem">Name: </span>{selectedVendorContact.contact_name}</div>
                )}
                {selectedVendorContact?.contact_phone && (
                    <div className="f-65rem"><span className="c-black f-75rem">Phone: </span>{selectedVendorContact.contact_phone}</div>
                )}
                {selectedVendorContact?.contact_fax && (
                    <div className="f-65rem"><span className="c-black f-75rem">Fax: </span>{selectedVendorContact.contact_fax}</div>
                )}
                {selectedVendorContact?.contact_email && (
                    <div className="f-65rem"><span className="c-black f-75rem">Email: </span>{selectedVendorContact.contact_email}</div>
                )}
            </div>
        );
    }

    showShipToVendorContactDetail = () => {
        const { selectedShipToVendorContact } = this.state;
        return (
            <div>
                {selectedShipToVendorContact?.contact_name && (
                    <div className="f-65rem"><span className="c-black f-75rem">Name: </span>{selectedShipToVendorContact.contact_name}</div>
                )}
                {selectedShipToVendorContact?.contact_phone && (
                    <div className="f-65rem"><span className="c-black f-75rem">Phone: </span>{selectedShipToVendorContact.contact_phone}</div>
                )}
                {selectedShipToVendorContact?.contact_fax && (
                    <div className="f-65rem"><span className="c-black f-75rem">Fax: </span>{selectedShipToVendorContact.contact_fax}</div>
                )}
                {selectedShipToVendorContact?.contact_email && (
                    <div className="f-65rem"><span className="c-black f-75rem">Email: </span>{selectedShipToVendorContact.contact_email}</div>
                )}
            </div>
        );
    }
    showBillToVendorContactDetail = () => {
        const { selectedBillToVendorContact } = this.state;
        return (
            <div>
                {selectedBillToVendorContact?.contact_name && (
                    <div className="f-65rem"><span className="c-black f-75rem">Name: </span>{selectedBillToVendorContact.contact_name}</div>
                )}
                {selectedBillToVendorContact?.contact_phone && (
                    <div className="f-65rem"><span className="c-black f-75rem">Phone: </span>{selectedBillToVendorContact.contact_phone}</div>
                )}
                {selectedBillToVendorContact?.contact_fax && (
                    <div className="f-65rem"><span className="c-black f-75rem">Fax: </span>{selectedBillToVendorContact.contact_fax}</div>
                )}
                {selectedBillToVendorContact?.contact_email && (
                    <div className="f-65rem"><span className="c-black f-75rem">Email: </span>{selectedBillToVendorContact.contact_email}</div>
                )}
            </div>
        );
    }

    getPOLines = (id) => {
        this.setState({ isFetchingPOLines: true });
        PostWatchService.getData(
            Constants.postWatchServiceBaseUrl + "/getpolineitems?poId=" + id,
            this.props?.userContext?.active_tenant?.tenant_id
        ).then(
            (response) => {
                this.setState(
                    {
                        poLinesList: response.data,
                        isFetchingPOLines: false,
                        postInitiated: false,
                    },
                    () => {
                        this.calculateSubtotal();
                    }
                );
            },
            (err) => {
                this.setState({
                    isFetchingPOLines: false,
                });
            }
        );
    };

    getMyVendors = () => {
        const queryParams = new URLSearchParams(this.props.location.search);
        const copyShowId = parseInt(queryParams.get('show_id'), 10) || this.props.location.state?.show_id;
        PostWatchService.getDataParams(
            Constants.postWatchServiceBaseUrl +
            `/getuservendors?userId=${this.props?.userContext?.user_profile?.user_id}&showId=${copyShowId}&pageNo=null&pageCount=null`, '',
            this.props?.userContext?.active_tenant?.tenant_id
        ).then(
            (response) => {
                this.setState({
                    vendorsList: response.data.records,
                    shipToVendorsList: response.data.records
                });
            },
            (err) => { }
        );
    };
    getUnit = () => {
        PostWatchService.getData(
            Constants.postWatchServiceBaseUrl +
            '/getlookupdata?objectType=unit',
            this.props?.userContext?.active_tenant?.tenant_id
        ).then(
            (response) => {
                let formattedList = [];
                formattedList = response.data?.results?.length > 0 && response.data?.results?.filter(unit => unit?.is_active === 1)?.map((item) => {
                        return ({ "label": item?.lookup_value, "value": item?.lookup_data_id })
                })
                optionalRightsConfigTenant3.headings[3].selectOptions = formattedList;
                this.setState({
                    unitOptions: response.data?.results || [],
                });
            },
            (err) => { }
        );
    }

    getPORange = () => {
        PostWatchService.getData(
            Constants.postWatchServiceBaseUrl +
            "/getporangedetails?showSeasonId=" +
            this.props?.selectedSeason?.show_season_id,
            this.props?.userContext?.active_tenant?.tenant_id
        ).then(
            (response) => {
                this.setState(
                    {
                        poRangeData: response.data,
                    },
                    () => {
                        this.setActivePORange();
                    }
                );
            },
            (err) => { }
        );
    };
    setActivePORange = () => {
        // Need to show only Active / Availble PO numbers
        let activePORange = _.filter(this.state.poRangeData, { is_avail: "1" });
        if (activePORange) {
            this.setState({ activPORangeList: activePORange });
        }
    };

    calculateSubtotal = () => {
        let subtotalCost = null;
        subtotalCost = this.state.poLinesList?.reduce((accumulator, item) => {
            return accumulator + item.subtotal;
        }, 0);
        subtotalCost = Number.parseFloat(subtotalCost).toFixed(2);
        this.setState({ subtotalCost });
    }

    updateRush = (rush) => {
        this.onPoHeaderChange('rush', rush);
    }
    saveInlineEdits = (data, index) => {
        if (this.validateBeforeSave(data[index])) {
            data[index].is_copy = Number("0");
            this.postData(data[index]);
        }
    };

    postData = (data) => {
        this.setState({ isFetchingPOLines: true });
        PostWatchService.postData(
            Constants.postWatchServiceBaseUrl +
            `/postpolineitem?userId=` +
            this.props?.userContext?.user_profile?.user_id,
            data,
            this.props?.userContext?.active_tenant?.tenant_id
        ).then(
            (response) => {
                if (!response.data.error) {
                    this.getPOLines(this.state?.poHeaders?.po_id);
                } else {
                    this.setState({ isFetchingPOLines: false });
                }
            },
            (err) => {
                this.setState({ isFetchingPOLines: false });
                console.log("Post polineitem error: " + err);
            }
        );
    };

    handleInlineEdits = (id, dataItem) => {
        let poLinesList = this.state.poLinesList;
        // Setunit and Acc are search select which require value and text to render in the table, so here we are building that object
        this.setState({
            poLinesList: poLinesList.map(
                (item) => {
                    if (item.po_line_id === id) {
                        item["editing"] = true;
                        if (this.props?.userContext?.active_tenant?.tenant_id !== 3) {
                            item["setunit_id"] = {
                                value: item["setunit_id"],
                                text: item["set_unit"],
                            };
                        }
                        item["chartofaccount_id"] = {
                            value: item["chartofaccount_id"],
                            text: item["acc_detail"],
                        };
                    }
                    return item;
                }
            ),
        });

    };

    handleCancelInlineEdits = () => {
        let poLinesList = this.state.poLinesList;
        this.setState({
            poLinesList: poLinesList.map((item) => {
                item["editing"] = false;
                return item;
            }),
        });
    };

    handleSyncPopupClick = () => { };
    handleClickEPSModal = () => { };

    validateBeforeSave = (newDataItem) => {
        let canSubmit = true

        return canSubmit;
    };

    handleAddNewItem = (newDataItem) => {
        this.setState({ postInitiated: true });
        if (newDataItem) {
            newDataItem.po_id = this.state?.poHeaders?.po_id;
            newDataItem.episode_id = this.props?.selectedEpisode?.episode_id;
            newDataItem.subtotal = newDataItem.quantity * newDataItem.unit_cost;
            this.postData(newDataItem);
        } else {
            // This will not clear already entered data
            optionalRightsConfigTenant3.isClearFields = false;
        }
    };

    onPoHeaderChange = (field, value) => {
        this.setState({ poErrormsg: false });
        switch (field) {
            case "cost_center_id":
                let selectedCostCenter = this.state.costCenterOptions?.filter(item => item.lookup_data_id === value)?.[0];
                this.setState(
                    (prevState) => ({
                        poHeaders: {
                            ...prevState.poHeaders,
                            [field]: value,
                            "cost_center_no": selectedCostCenter?.lookup_value
                        },
                    })
                );
                break;

            default:
                this.setState(
                    (prevState) => ({
                        poHeaders: {
                            ...prevState.poHeaders,
                            [field]: value,
                        },
                    })
                );
                break;
        }

    };

    validatePOHeaders = (seasonData) => {
        const regex = /^D\d{2}\.\d{6}\.\d{2}\.\d{2}$/;
        let canSubmit = (this.state.poHeaders?.po_number && this.state.poHeaders?.cost_center_id) || false;
        return canSubmit;
    };

    savePoHeader = () => {
        if (this.validatePOHeaders()) {
            PONo = this.state.poHeaders?.po_number;
            let postJson = JSON.parse(JSON.stringify(this.state.poHeaders));
            if(isValidYYYYMMDD(postJson.date_ordered)){
                postJson.date_ordered = getFormattedDate(postJson?.date_ordered);
            }
            if(isValidYYYYMMDD(postJson.date)){
                postJson.date = getFormattedDate(postJson?.date);
            }
            if(isValidYYYYMMDD(postJson.issue_date)){
                postJson.issue_date = getFormattedDate(postJson?.issue_date);
            }
            if(isValidYYYYMMDD(postJson.modified_date)){
                postJson.modified_date = getFormattedDate(postJson?.modified_date);
            }

            this.setState({ isFetchingPoHeaders: true });
            PostWatchService.postData(
                Constants.postWatchServiceBaseUrl +
                `/postpoheader?userId=` +
                this.props?.userContext?.user_profile?.user_id,
                postJson,
                this.props?.userContext?.active_tenant?.tenant_id
            ).then(
                (response) => {
                    if (response.data[0]?.po_id == 0) {
                        this.props.userContext?.getPORange(
                            this.props?.selectedSeason?.show_season_id,
                            this.props?.userContext?.active_tenant?.tenant_id
                        );
                        this.setState({ poErrormsg: true, isFetchingPoHeaders: false });
                    }
                    else if (!response.data.error) {
                        this.setState({
                            isFetchingPoHeaders: false,
                            poSuccess: true
                        });
                        this.getPOHeaders(
                            this.props?.selectedEpisode?.episode_id,
                            response.data[0]?.po_id
                        );
                        this.getPOLines(response.data[0]?.po_id);
                    } else {
                        this.setState({ isFetchingPoHeaders: false });
                    }
                },
                (err) => {
                    this.setState({ isFetchingPoHeaders: false });
                    console.log("Post poHeaders error: " + err);
                }
            );
        }
    };

    setPSTToLocalDate = (modifiedDate) =>{
        const dateInLocal = moment.tz(modifiedDate, "YYYY-MM-DD HH:mm:ss", "America/Los_Angeles").local();
        return dateInLocal.format('YYYY-MM-DD');
    }   
    getPOHeaders = (id, poId) => {
        this.setState({ isFetchingPOHeaders: true });
        PostWatchService.getData(
            Constants.postWatchServiceBaseUrl +
            "/getpoheaders?episodeId=" +
            id +
            "&showSeasonId=" +
            this.props.selectedSeason?.show_season_id,
            this.props?.userContext?.active_tenant?.tenant_id
        ).then(
            (response) => {
                // For newly created PO po_id will be null so take if from response
                let POID = null;
                if (!this.state.poHeaders?.po_id) {
                    POID = poId;
                    // Get updated PO range label upon new PO created
                    this.getPORangeLabel(this.props.selectedSeason?.show_season_id);
                } else {
                    POID = this.state.poHeaders?.po_id;
                }
                let header = _.find(response.data, {
                    po_id: POID,
                });
                if (header?.is_void === 1) {
                    optionalRightsConfigTenant3.actions = ["", "file", "info-circle", "", ""];
                } else {
                    optionalRightsConfigTenant3.actions = ["copy", "file", "info-circle", "pen", "trash-alt"];
                }
                this.setState({
                    poHeaders: header || {},
                    isFetchingPOHeaders: false
                });
            },
            (err) => {
                this.setState({
                    isFetchingPOHeaders: false,
                });
            }
        );
    };

    getPORangeLabel = (showSeasonId) => {
        PostWatchService.getData(
            Constants.postWatchServiceBaseUrl +
            "/getshowseasonporange?showSeasonId=" +
            showSeasonId,
            this.props?.userContext?.active_tenant?.tenant_id
        ).then(
            (response) => {
                this.props.userContext.setPoRangeLabel(response.data[0].po_range);
            },
            (err) => { }
        );
    };

    expandVendorField(edit) {
        this.setState({ vendorExpand: edit === 1 ? true : false })
        if (edit !== 1 && this.state.clearVendor) {
            this.onPoHeaderChange("po_vendor_location_id", null);
            this.onPoHeaderChange("po_vendor_contact_id", null);
            this.onPoHeaderChange("vendor_id", null);
            this.setState({
                clearVendor: false,
                selectedVendor: null, selectedVendorLocation: null, selectedVendorLocationList: null, selectedVendorContact: null, selectedVendorContactList: null,
                lastSavedVendor: null
            });
        } else {
            //this.resetVendor();
            this.setState({ clearVendor: false });
        }
        if (edit === 0 && !this.state.clearVendor) {
            this.setState({ savedVendor: true });
            this.setState({
                lastSavedVendor: {
                    vendor_name: this.state.selectedVendor?.vendor_name,
                    vendor_id: this.state.selectedVendor?.vendor_id,
                    vendor_locations: this.state.selectedVendor?.vendor_locations,
                    vendor_contacts: this.state.selectedVendor?.vendor_contacts,
                    po_vendor_location_id: this.state.poHeaders?.po_vendor_location_id,
                    po_vendor_contact_id: this.state.poHeaders?.po_vendor_contact_id
                },
                selectedVendorLocationList: this.state.selectedVendor?.vendor_locations,
                selectedVendorContactList: this.state.selectedVendor?.vendor_contacts,
            });
        }

    }

    resetVendor() {
        let selectedVendorLocation = _.find(
            this.state.lastSavedVendor?.vendor_locations,
            { vendor_location_id: this.state.lastSavedVendor?.po_vendor_location_id }
        );
        let selectedVendorContact = _.find(
            this.state.lastSavedVendor?.vendor_contacts,
            { vendor_contact_id: this.state.lastSavedVendor?.po_vendor_contact_id }
        );
        this.setState({
            selectedVendor: {
                vendor_name: this.state.lastSavedVendor?.vendor_name,
                vendor_id: this.state.lastSavedVendor?.vendor_id,
                vendor_locations: this.state.lastSavedVendor?.vendor_locations,
                vendor_contacts: this.state.lastSavedVendor?.vendor_contacts,
            },
            selectedVendorLocation: selectedVendorLocation,
            selectedVendorContact: selectedVendorContact,
            selectedVendorLocationList: this.state.lastSavedVendor?.vendor_locations,
            selectedVendorContactList: this.state.lastSavedVendor?.vendor_contacts,
            po_vendor_location_id: this.state.lastSavedVendor?.po_vendor_location_id,
            po_vendor_contact_id: this.state.lastSavedVendor?.po_vendor_contact_id
        });
        this.onPoHeaderChange("vendor_id", this.state.lastSavedVendor?.vendor_id);
        this.onPoHeaderChange("po_vendor_location_id", this.state.lastSavedVendor?.po_vendor_location_id);
        this.onPoHeaderChange("po_vendor_contact_id", this.state.lastSavedVendor?.po_vendor_contact_id);
    }
    resetBillTo() {
        let selectedBillToVendorLocation = _.find(
            this.state.lastSavedBillTo?.vendor_locations,
            { vendor_location_id: this.state.lastSavedBillTo?.po_bill_to_location_id }
        );
        let selectedBillToVendorContact = _.find(
            this.state.lastSavedBillTo?.vendor_contacts,
            { vendor_contact_id: this.state.lastSavedBillTo?.po_bill_to_contact_id }
        );
        this.setState({
            selectedBillToVendor: {
                vendor_name: this.state.lastSavedBillTo?.vendor_name,
                vendor_id: this.state.lastSavedBillTo?.vendor_id,
                vendor_locations: this.state.lastSavedBillTo?.vendor_locations,
                vendor_contacts: this.state.lastSavedBillTo?.vendor_contacts,
            },
            selectedBillToVendorLocation: selectedBillToVendorLocation,
            selectedBillToVendorLocationList: this.state.lastSavedBillTo?.vendor_locations,
            selectedBillToVendorContact: selectedBillToVendorContact,
            selectedBillToVendorContactList: this.state.lastSavedBillTo?.vendor_contacts,
        });
        this.onPoHeaderChange("vendor_id", this.state.lastSavedBillTo?.vendor_id);
        this.onPoHeaderChange("po_bill_to_location_id", this.state.lastSavedBillTo?.po_bill_to_location_id);
        this.onPoHeaderChange("po_bill_to_contact_id", this.state.lastSavedBillTo?.po_bill_to_contact_id);
    }
    resetShipTo() {
        let selectedShipToVendorLocation = _.find(
            this.state.lastSavedShipTo?.vendor_locations,
            { vendor_location_id: this.state.lastSavedShipTo?.po_ship_to_location_id }
        );
        let selectedShipToVendorContact = _.find(
            this.state.lastSavedShipTo?.vendor_contacts,
            { vendor_contact_id: this.state.lastSavedShipTo?.po_ship_to_contact_id }
        );
        this.setState({
            selectedShipToVendor: {
                vendor_name: this.state.lastSavedShipTo?.vendor_name,
                vendor_id: this.state.lastSavedShipTo?.vendor_id,
                vendor_locations: this.state.lastSavedShipTo?.vendor_locations,
                vendor_contacts: this.state.lastSavedShipTo?.vendor_contacts,
            },
            selectedShipToVendorLocation: selectedShipToVendorLocation,
            selectedShipToVendorLocationList: this.state.lastSavedShipTo?.vendor_locations,
            selectedShipToVendorContact: selectedShipToVendorContact,
            selectedShipToVendorContactList: this.state.lastSavedShipTo?.vendor_contacts,
        });
        this.onPoHeaderChange("vendor_id", this.state.lastSavedShipTo?.vendor_id);
        this.onPoHeaderChange("po_ship_to_location_id", this.state.lastSavedShipTo?.po_ship_to_location_id);
        this.onPoHeaderChange("po_ship_to_contact_id", this.state.lastSavedShipTo?.po_ship_to_contact_id);
    }

    clearVendorField = () => {
        this.resetVendor();
        this.setState({ vendorExpand: false })
    }

    // clearShipToField = () => {
    //     this.resetShipTo();
    //     this.setState({ shipToExpand: false })
    // }
    // clearBillToField = () => {
    //     this.resetBillTo();
    //     this.setState({ billToExpand: false })
    // }
    // expandBillToField = (edit) => {
    //     this.setState({ billToExpand: edit === 1 ? true : false })
    //     if (edit !== 1 && this.state.clearBillTo) {
    //         this.onPoHeaderChange("po_bill_to_location_id", null);
    //         this.onPoHeaderChange("po_bill_to_contact_id", null);
    //         this.onPoHeaderChange("bill_to_id", null);
    //         this.setState({
    //             clearBillTo: false,
    //             selectedBillToVendor: null, selectedBillToVendorLocation: null, selectedBillToVendorLocationList: null,
    //             selectedBillToVendorContact: null, selectedBillToVendorContactList: null, lastSavedBillTo: null
    //         });
    //     } else {
    //         this.setState({ clearBillTo: false });
    //     }
    //     if (edit === 0 && !this.state.clearBillTo) {
    //         this.setState({ savedVendor: true });
    //         this.setState({
    //             lastSavedBillTo: {
    //                 vendor_id: this.state.selectedBillToVendor?.vendor_id,
    //                 vendor_name: this.state.selectedBillToVendor?.vendor_name,
    //                 vendor_locations: this.state.selectedBillToVendor?.vendor_locations,
    //                 vendor_contacts: this.state.selectedBillToVendor?.vendor_contacts,
    //                 po_bill_to_location_id: this.state.poHeaders?.po_bill_to_location_id,
    //                 po_bill_to_contact_id: this.state.poHeaders?.po_bill_to_contact_id
    //             }
    //         });
    //     }

    // }

    // expandShipTOField = (edit) => {
    //     this.setState({ shipToExpand: edit === 1 ? true : false })
    //     if (edit !== 1 && this.state.clearShipTo) {
    //         this.onPoHeaderChange("po_ship_to_location_id", null);
    //         this.onPoHeaderChange("po_ship_to_contact_id", null);
    //         this.onPoHeaderChange("ship_to_id", null);
    //         this.setState({
    //             clearShipTo: false,
    //             selectedShipToVendor: null, selectedShipToVendorLocation: null, selectedShipToVendorLocationList: null,
    //             selectedShipToVendorContact: null, selectedShipToVendorContactList: null, lastSavedShipTo: null
    //         });
    //     } else {
    //         this.setState({ clearShipTo: false });
    //     }
    //     if (edit === 0 && !this.state.clearShipTo) {
    //         this.setState({ savedVendor: true });
    //         this.setState({
    //             lastSavedShipTo: {
    //                 vendor_id: this.state.selectedShipToVendor?.vendor_id,
    //                 vendor_name: this.state.selectedShipToVendor?.vendor_name,
    //                 vendor_locations: this.state.selectedShipToVendor?.vendor_locations,
    //                 vendor_contacts: this.state.selectedShipToVendor?.vendor_contacts,
    //                 po_ship_to_location_id: this.state.poHeaders?.po_ship_to_location_id,
    //                 po_ship_to_contact_id: this.state.poHeaders?.po_ship_to_contact_id
    //             },
    //             // selectedShipToVendorLocationList:this.state.selectedVendor?.vendor_locations,
    //             // selectedShipToVendorContactList:this.state.selectedVendor?.vendor_contacts,
    //         });
    //     }

    // }
    onBillToVendorSelection = (item) => {
        let vendor = _.find(this.state.billToVendorsList, { vendor_id: item?.value });
        if (vendor) {
            vendor = {
                ...{ vendor_id: item.value, vendor_name: item.text },
                ...{ vendor_locations: vendor?.vendor_locations },
                ...{ vendor_contacts: vendor?.vendor_contacts },
            };
            this.setState(
                {
                    selectedBillToVendor: { ...vendor },
                    selectedBillToVendorLocation: vendor?.vendor_locations?.[0],
                    selectedBillToVendorLocationList: vendor?.vendor_locations,
                    selectedBillToVendorContact: vendor?.vendor_contacts?.[0],
                    selectedBillToVendorContactList: vendor?.vendor_contacts,
                    clearBillTo: false
                },
                () => { }
            );

            this.onPoHeaderChange("bill_to_id", item?.value);
            this.onPoHeaderChange("po_bill_to_location_id", vendor?.vendor_locations?.[0]?.vendor_location_id);
            this.onPoHeaderChange("po_bill_to_contact_id", vendor?.vendor_contacts?.[0]?.vendor_contact_id);
        } else {
            this.setState({ clearBillTo: true })
            this.setState({
                selectedBillToVendor: null, selectedBillToVendorLocation: null,
                selectedBillToVendorLocationList: null, selectedBillToVendorContactList: null,
                selectedBillToVendorContact: null
            });
        }
    };
    onShipToVendorSelection = (item) => {
        let vendor = _.find(this.state.shipToVendorsList, { vendor_id: item?.value });
        if (vendor) {
            vendor = {
                ...{ vendor_id: item.value, vendor_name: item.text },
                ...{ vendor_locations: vendor?.vendor_locations },
                ...{ vendor_contacts: vendor?.vendor_contacts },
            };
            this.setState(
                {
                    selectedShipToVendor: { ...vendor },
                    selectedShipToVendorLocation: vendor?.vendor_locations?.[0],
                    selectedShipToVendorLocationList: vendor?.vendor_locations,
                    selectedShipToVendorContact: vendor?.vendor_contacts?.[0],
                    selectedShipToVendorContactList: vendor?.vendor_contacts,
                    clearShipTo: false
                },
                () => { }
            );

            this.onPoHeaderChange("ship_to_id", item?.value);
            this.onPoHeaderChange("po_ship_to_location_id", vendor?.vendor_locations?.[0]?.vendor_location_id);
            this.onPoHeaderChange("po_ship_to_contact_id", vendor?.vendor_contacts?.[0]?.vendor_contact_id);
        } else {
            this.setState({ clearShipTo: true })
            this.setState({
                selectedShipToVendor: null, selectedShipToVendorLocation: null,
                selectedShipToVendorLocationList: null, selectedShipToVendorContactList: null,
                selectedShipToVendorContact: null
            });
        }
    };

    onVendorSelection = (item) => {
        let vendor = _.find(this.state.vendorsList, { vendor_id: item?.value });
        if (vendor) {
            vendor = {
                ...{ vendor_id: item.value, vendor_name: item.text },
                ...{ vendor_locations: vendor.vendor_locations },
                ...{ vendor_contacts: vendor.vendor_contacts },
            };
            this.setState(
                {
                    selectedVendor: { ...vendor },
                    selectedVendorLocation: vendor?.vendor_locations?.[0],
                    selectedVendorLocationList: vendor?.vendor_locations,
                    selectedVendorContact: vendor?.vendor_contacts?.[0],
                    selectedVendorContactList: vendor?.vendor_contacts,
                    clearVendor: false
                },
                () => {
                    this.onPoHeaderChange("vendor_id", item.value);
                    this.onPoHeaderChange("po_vendor_location_id", vendor?.vendor_locations?.[0]?.vendor_location_id);
                    this.onPoHeaderChange("po_vendor_contact_id", vendor?.vendor_contacts?.[0]?.vendor_contact_id);
                }
            );
        } else {
            this.setState({
                clearVendor: true,
                selectedVendor: null, selectedVendorLocation: null, selectedVendorLocationList: null,
                selectedVendorContact: null, selectedVendorContactList: null
            });
        }
    };
    onUserSelection = (item, field) => {
        let user = null;
        switch (field) {
            case "requested_by_id":
                user = _.find(this.state.requestedByUserList, { user_id: item?.value });
                break;
            case "issued_by_id":
                user = _.find(this.state.issuedByUserList, { user_id: item?.value });
                break;
            case "approver_id":
                user = _.find(this.state.approvedByUserList, { user_id: item?.value });
                break;
            case "department_head_id":
                user = _.find(this.state.deptHeadUserList, { user_id: item?.value });
                break;
        }
        if (user) {
            user = {
                ...{ user_id: item.value, user_name: item.text }
            };
            switch (field) {
                case "requested_by_id":
                    this.setState({
                        selectedRequestedByUser: { ...user },
                    },
                        () => {
                            this.onPoHeaderChange("requested_by_id", item.value);
                            this.onPoHeaderChange("requested_by_name", item.text);
                        });
                    break;
                case "issued_by_id":
                    this.setState({
                        selectedIssuedByUser: { ...user },
                    },
                        () => {
                            this.onPoHeaderChange("issued_by_id", item.value);
                            this.onPoHeaderChange("issued_by_name", item.text);
                        });
                    break;
                case "approver_id":
                    this.setState({
                        selectedApprovedByUser: { ...user },
                    },
                        () => {
                            this.onPoHeaderChange("approver_id", item.value);
                            this.onPoHeaderChange("approver_name", item.text);
                        });
                    break;
                case "department_head_id":
                    this.setState({
                        selectedDeptHeadUser: { ...user },
                    },
                        () => {
                            this.onPoHeaderChange("department_head_id", item.value);
                            this.onPoHeaderChange("department_head_name", item.text);
                        });
                    break;

                default:
                    break;
            }
        } else {
            switch (field) {
                case "requested_by_id":
                    this.setState({
                        selectedRequestedByUser: null
                    }, () => {
                        this.onPoHeaderChange("requested_by_id", null);
                        this.onPoHeaderChange("requested_by_name", null);
                    });
                    break;
                case "issued_by_id":
                    this.setState({
                        selectedIssuedByUser: null
                    }, () => {
                        this.onPoHeaderChange("issued_by_id", null);
                        this.onPoHeaderChange("issued_by_name", null);
                    });
                    break;
                case "approver_id":
                    this.setState({
                        selectedApprovedByUser: null
                    }, () => {
                        this.onPoHeaderChange("approver_id", null);
                        this.onPoHeaderChange("approver_name", null);
                    });
                    break;
                case "department_head_id":
                    this.setState({
                        selectedDeptHeadUser: null
                    }, () => {
                        this.onPoHeaderChange("department_head_id", null);
                        this.onPoHeaderChange("department_head_name", null);
                    });
                    break;
                default:
                    break;
            }
        }
    };
    searchVendors = (e, field) => {
        if (this.state.searchCancelToken != null)
            this.state.searchCancelToken.cancel(
                "Operation canceled due to new request"
            );
        var cancelToken = axios.CancelToken.source();
        this.setState({ searchCancelToken: cancelToken });
        if (e.target.value !== null) {
            this.setState({ isFetchingVendors: true });
            PostWatchService.getDataWithCancel(
                Constants.postWatchServiceBaseUrl +
                `/getvendorsbyname?vendorName=${e.target.value}&userId=${this.props?.userContext?.user_profile?.user_id}&showId=${this.props?.show_id}`,
                cancelToken,
                this.props?.userContext?.active_tenant?.tenant_id,
                1
            ).then(
                (response) => {
                    switch (field) {
                        case 'VEN':
                            this.setState({
                                vendorsList: response.data,
                                isFetchingVendors: false,
                            });
                            break;
                        case 'SHIP':
                            this.setState({
                                shipToVendorsList: response.data,
                                isFetchingVendors: false,
                            });
                            break;
                        case 'BILL':
                            this.setState({
                                billToVendorsList: response.data,
                                isFetchingVendors: false,
                            });
                            break;
                    }
                },
                (err) => {
                    this.setState({
                        isFetchingVendors: false,
                    });
                }
            );
        }
    };

    searchUsers = (e,field=null) => {
        if (this.state.searchCancelToken != null)
            this.state.searchCancelToken.cancel(
                "Operation canceled due to new request"
            );
        var cancelToken = axios.CancelToken.source();
        this.setState({ searchCancelToken: cancelToken });
        if (e.target.value !== null) {
            this.setState({ isFetchingUsers: true });
            PostWatchService.getDataWithCancel(
                Constants.postWatchServiceBaseUrl +
                `/getlookupdata?objectType=user&searchString=${e.target.value}`,
                cancelToken,
                this.props?.userContext?.active_tenant?.tenant_id,
                1
            ).then(
                (response) => {
                    switch (field) {
                        case "requested_by_id":
                            this.setState({
                                requestedByUserList: response.data?.results,
                                isFetchingUsers: false,
                            });
                            break;
                        case "issued_by_id":
                            this.setState({
                                issuedByUserList: response.data?.results,
                                isFetchingUsers: false,
                            });
                            break;
                        case "approver_id":
                            this.setState({
                                approvedByUserList: response.data?.results,
                                isFetchingUsers: false,
                            });
                            break;
                        case "department_head_id":
                            this.setState({
                                deptHeadUserList: response.data?.results,
                                isFetchingUsers: false,
                            });
                            break;
                    
                        default:
                            break;
                    }
                    
                },
                (err) => {
                    this.setState({
                        isFetchingUsers: false,
                    });
                }
            );
        }
    };

    vendorLocationChange = (id) => {
        let location = _.find(this.state?.selectedVendor?.vendor_locations, {
            vendor_location_id: id,
        });
        if (location) {
            this.setState({ selectedVendorLocation: location });
        }
        this.onPoHeaderChange("po_vendor_location_id", id);
    };

    shipToLocationChange = (id) => {
        let location = _.find(this.state?.selectedShipToVendor?.vendor_locations, {
            vendor_location_id: id,
        });
        if (location) {
            this.setState({ selectedShipToVendorLocation: location });
        }
        this.onPoHeaderChange("po_ship_to_location_id", id);
    };


    vendorContactChange = (id) => {
        let contact = _.find(this.state?.selectedVendor?.vendor_contacts, {
            vendor_contact_id: id,
        });
        if (contact) {
            this.setState({ selectedVendorContact: contact });
        }
        this.onPoHeaderChange("po_vendor_contact_id", id);
    };

    shipToContactChange = (id) => {
        let contact = _.find(this.state?.selectedShipToVendor?.vendor_contacts, {
            vendor_contact_id: id,
        });
        if (contact) {
            this.setState({ selectedShipToVendorContact: contact });
        }
        this.onPoHeaderChange("po_ship_to_contact_id", id);
    };

    handleDelCallBack = (id, dataItem) => {
        let data = dataItem;
        data.is_deleted = 1;
        this.postData(data);
    };

    handleCommentBox = (e, data) => {
        let poLine = _.find(this.state?.poLinesList, {
            po_line_id: data.po_line_id,
        });
        this.setState({
            anchorEl: e.currentTarget,
            openPopover: true,
            selectedNoteRow: poLine,
            selectedNoteMessage: data.notes || null,
        });
    };
    handleOnNoteChange = (value) => {
        this.setState({ selectedNoteMessage: value });
    };
    handleClose = () => {
        this.setState({ anchorEl: null, openPopover: false });
    };
    saveNotes = () => {
        let noteRow = JSON.parse(JSON.stringify(this.state.selectedNoteRow));
        noteRow.notes = this.state.selectedNoteMessage;
        noteRow.setunit_id = noteRow?.setunit_id?.value
            ? noteRow?.setunit_id?.value
            : noteRow?.setunit_id;
        noteRow.chartofaccount_id = noteRow?.chartofaccount_id?.value
            ? noteRow?.chartofaccount_id?.value
            : noteRow?.chartofaccount_id;
        this.postData(noteRow);
        this.handleClose();
    };

    onVoidClick = (value) => {
        let poHeaders = { ...this.state.poHeaders };
        poHeaders.is_void = value;
        /* If any row of the table is in edit mode, make it to normal mode.*/
        this.handleCancelInlineEdits();
        this.setState(
            { poHeaders, selectedTemplate: null, selectedTemplatePONumber: null },
            () => {
                this.savePoHeader();
            }
        );
    };

    handleTemplateChange = (field, value) => {
        if (field === "template") {
            let template = _.find(this.props?.userContext?.templateItems, {
                po_template_header_id: value,
            });
            if (template) {
                this.setState({ selectedTemplate: template });
            }
        }

        if (field === "ponumber") {
            if (value) {
                this.setState({ selectedTemplatePONumber: value });
            }
        }
    };
    loadTemplatePOLines = () => {
        if (this.state?.selectedTemplate
            // && this.state?.selectedTemplatePONumber
        ) {
            this.getTemplatePOLines();
        }
    };

    getTemplatePOLines = () => {
        this.setState({ isFetchingPOLines: true });
        PostWatchService.getData(
            Constants.postWatchServiceBaseUrl +
            "/getpotemplates?poTemplateHeaderId=" +
            this.state.selectedTemplate.po_template_header_id,
            this.props?.userContext?.active_tenant?.tenant_id
        ).then(
            (response) => {
                let poLinesList = JSON.parse(JSON.stringify(this.state.poLinesList));
                if (poLinesList === null) {
                    poLinesList = [];
                }

                let templatePOLines = response.data;
                // Add these two propeties since they dont come with template po lines
                _.forEach(templatePOLines, (item) => {
                    item.po_line_id = null;
                    item.po_id = this.state.poHeaders?.po_id;
                    item.episode_id = this.props?.selectedEpisode?.episode_id;
                    // Add GL Number only if template po line does not have GL number
                    if (!item.gl_number) {
                        item.gl_number = this.state?.selectedTemplatePONumber;
                    }
                });
                poLinesList = [...poLinesList, ...templatePOLines];
                this.postAllPOlineItems(poLinesList);
            },
            (err) => {
                this.setState({
                    isFetchingPOLines: false,
                });
            }
        );
    };
    postAllPOlineItems = (data) => {
        this.setState({ isFetchingPOLines: true });
        PostWatchService.postData(
            Constants.postWatchServiceBaseUrl +
            `/postallpolineitems?userId=` +
            this.props?.userContext?.user_profile?.user_id,
            data,
            this.props?.userContext?.active_tenant?.tenant_id
        ).then(
            (response) => {
                if (!response.data.error) {
                    this.setState({
                        isFetchingPOLines: false,
                        postInitiated: false,
                    });
                    this.getPOLines(this.state?.poHeaders?.po_id);
                } else {
                    this.setState({ isFetchingPOLines: false });
                }
            },
            (err) => {
                this.setState({ isFetchingPOLines: false });
                console.log("Post postallpolineitems error: " + err);
            }
        );
    };

    downloadShowReport = () => {
        this.setState({ isFetchingShowReport: true });
        let orientation = this.state.orientation || ''; -
            PostWatchService.getDataParams(
                Constants.postWatchServiceBaseUrl +
                `/getexportpodetails?reportName=po_report_p&userId=` +
                this.props?.userContext?.user_profile?.user_id +
                "&poId=" +
                this.state.poHeaders?.po_id,
                "",
                this.props.userContext?.active_tenant?.tenant_id
            ).then(
                (response) => {
                    this.downloadUrl(response.data, "Show");
                    this.setState({
                        isFetchingShowReport: false,
                    });
                },
                (err) => {
                    this.setState({
                        isFetchingShowReport: false,
                    });
                }
            );
    };

    downloadUrl = (url, reportName) => {
        window.open(url, "_blank");
    };

    handleCloseCopyPo = () => {
        this.setState({ showCopyPoModal: false })
    }
    handleInlineCopy = (copyRecord) => {
        if (this.validateBeforeSave(copyRecord)) {
            // Since these are searchtext they will return item with value and label from which we need to send only id
            // If dropdowns are not changed then take direct number, if dropdown are changed then we get objects so take ?.value
            copyRecord.setunit_id = copyRecord?.setunit_id?.value
                ? copyRecord?.setunit_id?.value
                : copyRecord?.setunit_id;
            copyRecord.chartofaccount_id = copyRecord?.chartofaccount_id?.value
                ? copyRecord?.chartofaccount_id?.value
                : copyRecord?.chartofaccount_id;
            // Service side require "adj_currency_id" and "adj_curr_exch_rate" for some calculation so appending these well
            let currencyItem = _.find(this.state.currencies, {
                currency_exchange: copyRecord.currency_exchange,
            });

            if (currencyItem) {
                copyRecord.adj_currency_id = currencyItem.currency_id;
                copyRecord.adj_curr_exch_rate = currencyItem.exchange_rate;
            }
            copyRecord.is_copy = Number("1");
            this.postData(copyRecord);
        }
    }

    handleResetNotify = () => {
        this.setState({ poSuccess: false });
    }
    onCopyPO = (event) => {
        this.setState({ showCopyPoModal: true, anchorEl: event.currentTarget })
    }

    render() {
        let selectedShow = { value: this.props?.showDetails?.show_id, text: this.props?.showDetails?.show_name }
        return (
            <>
                <MDBRow className="mb-2">
                    <NotificationComponent
                        open={
                            this.state.poSuccess
                        }
                        message={"PO Saved Successfully"}
                        severity={"success"}
                        handleResetNotify={this.handleResetNotify.bind(this)}
                    />
                    <MDBCol md={6}>
                        <Link component={RouterLink} className="backToPOLink" to={"/"} >
                            <div className="f-85rem c-black">
                                <span className="cursor-pointer" onClick={this.props.backToPO}>
                                    <ArrowBack className="me-2" />
                                    Back to Purchase Order Grid
                                </span>
                            </div>
                        </Link>
                    </MDBCol>
                    <MDBCol
                        md={6}
                        className="d-flex justify-content-end align-items-center"
                    >
                        <Popover
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "left",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            id={"popovercopy"}
                            className="pop-over"
                            open={this.state.showCopyPoModal}
                            anchorEl={this.state.anchorEl}
                            PaperProps={{ style: { width: '20%' } }}
                            onClose={this.handleCloseCopyPo.bind(this)}>
                            <MDBRow>
                                <MDBCol md={12}>
                                    <CreatePO
                                        isCopyPo={true}
                                        onClose={this.handleCloseCopyPo.bind(this)}
                                        selectedCopyShow={selectedShow}
                                        season_id={this.props?.selectedSeason?.season_id}
                                        poHeaders={this.state.poHeaders}
                                    />
                                </MDBCol>
                            </MDBRow>
                        </Popover>

                        <BasicButton
                            className="me-3"
                            text={"Copy PO"}
                            icon={"copy"}
                            onClick={(event) => this.onCopyPO(event)}
                        />
                        <BasicButton
                            className="me-3"
                            text={
                                this.state.isFetchingShowReport ? (
                                    <CircularProgress color="inherit" size={20} />
                                ) : (
                                    "PDF"
                                )
                            }
                            icon={"file"}
                            onClick={this.downloadShowReport}
                        />
                        <BasicButton
                            text={
                                this.state.isFetchingPoHeaders ? (
                                    <CircularProgress color="inherit" size={20} />
                                ) : (
                                    "Save"
                                )
                            }
                            variant="contained"
                            type="inline"
                            icon={"save"} onClick={this.savePoHeader}
                        />
                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    <MDBCol md={12}>
                        <MDBCard className="">
                            <MDBCardBody>
                                <MDBCardText>
                                    <MDBRow>
                                        <MDBCol md={3} className="poContainer">
                                            <div className="topRow">
                                                <div className={!this.state.poHeaders?.po_id ? "tenant3Container" : `poFiledView tenant3Container`}>
                                                    <div className="f-75rem c-black">PO No.</div>
                                                    <div className="poNoContainer">
                                                        <span className="f-65rem c-black">
                                                            {this.props?.preFix}
                                                        </span>
                                                        {!this.state.poHeaders?.po_id ? (
                                                            <SelectField
                                                                className="sh-select"
                                                                value={this.state.poHeaders?.po_number || null}
                                                                disabled={this.state.poHeaders?.is_void}
                                                                options={this.props?.userContext?.poRangeActiveItems?.map(
                                                                    (item) => {
                                                                        return {
                                                                            value: item.po_number,
                                                                            label: item.po_number,
                                                                        };
                                                                    }
                                                                )}
                                                                placeHolderText="- Select -"
                                                                onChange={(e, value) =>
                                                                    this.onPoHeaderChange(
                                                                        "po_number",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                showMandatory={true}
                                                                isMandatory={true}
                                                            />
                                                        ) : (
                                                            <span className="f-65rem c-black">
                                                                &nbsp;{this.state.poHeaders?.po_number}
                                                            </span>
                                                        )}
                                                    </div>
                                                    {this.state.poErrormsg && <p className="errorText">PO No.{PONo} Already Used</p>}

                                                    {this.state.poHeaders?.is_void ? (
                                                        <div className="f-75rem redStar mt-4">VOIDED</div>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md={3} className="vendorField">
                                            <div className="f-75rem c-black">Vendor
                                                {!this.state.vendorExpand ?
                                                    <MDBIcon
                                                        className="cursor-pointer ml2"
                                                        aria-controls="simple-menu"
                                                        aria-haspopup="true"
                                                        color={"primary"}
                                                        fontSize={10}
                                                        onClick={() => this.expandVendorField(1)}
                                                        icon={"pen"}
                                                    />
                                                    :
                                                    <>
                                                        <MDBIcon
                                                            className="cursor-pointer ml2"
                                                            aria-controls="simple-menu"
                                                            aria-haspopup="true"
                                                            color={"primary"}
                                                            fontSize={10}
                                                            onClick={() => this.expandVendorField(0)}
                                                            icon={"save"}
                                                        />
                                                        <MDBIcon
                                                            className="cursor-pointer ml2"
                                                            aria-controls="simple-menu"
                                                            aria-haspopup="true"
                                                            color={"primary"}
                                                            fontSize={10}
                                                            onClick={() => this.clearVendorField(0)}
                                                            icon={"times"}
                                                        />
                                                    </>
                                                }
                                            </div>
                                            <div className="inline">
                                                {!this.state.vendorExpand &&
                                                    <div className="f-65rem c-black ">{this.state?.selectedVendor?.vendor_name
                                                        ?? '-NA-'}</div>
                                                }
                                                {this.state.vendorExpand &&
                                                    <SearchSelectField
                                                        className="first"
                                                        detail_selected={
                                                            !this.state.clearVendor && this.state?.selectedVendor?.vendor_id
                                                                ? {
                                                                    value: this.state?.selectedVendor?.vendor_id,
                                                                    text: this.state?.selectedVendor?.vendor_name,
                                                                }
                                                                : null
                                                        }
                                                        options={this.state.vendorsList?.map((item) => ({
                                                            text: item.vendor_name,
                                                            value: item.vendor_id,
                                                            is_active: item.is_active,
                                                            is_favourite: item.is_favourite,
                                                        }))}
                                                        loading={this.state.isFetchingVendors}
                                                        width="100%"
                                                        disabled={!this.state.vendorExpand}
                                                        multiple={false}
                                                        searchSelect={true}
                                                        searchText={(event) => { this.searchVendors(event, 'VEN') }}
                                                        placeholder="- Type to search vendors -"
                                                        noOptionsText="No results"
                                                        valueSelected={(e, newValue) => {
                                                            this.onVendorSelection(newValue);
                                                        }}
                                                    />
                                                }
                                            </div>
                                            {this.state.vendorExpand && (
                                                <>
                                                    <SelectField
                                                        value={this.state.poHeaders?.po_vendor_location_id}
                                                        options={this.state?.selectedVendorLocationList?.map(
                                                            (item, index) => {
                                                                return {
                                                                    value: item.vendor_location_id,
                                                                    label: item.location_name ? item.location_name : `Location ${index}`,
                                                                };
                                                            }
                                                        )}
                                                        onChange={(e, value) =>
                                                            this.vendorLocationChange(e.target.value)
                                                        }
                                                        disabled={this.state.poHeaders?.is_void}
                                                        placeHolderText="Select Location"
                                                    />


                                                    <SelectField
                                                        value={this.state.poHeaders?.po_vendor_contact_id}
                                                        options={this.state?.selectedVendorContactList?.map(
                                                            (item, index) => {
                                                                return {
                                                                    value: item.vendor_contact_id,
                                                                    label: item.contact_name ? item.contact_name : `Contact ${index}`,
                                                                };
                                                            }
                                                        )}
                                                        onChange={(e, value) =>
                                                            this.vendorContactChange(e.target.value)
                                                        }
                                                        disabled={this.state.poHeaders?.is_void}
                                                        placeHolderText="Select Contact"
                                                        className="last"
                                                    />

                                                </>
                                            )}
                                            {!this.state.vendorExpand && this.state.selectedVendorLocation
                                                ?.location_address && (
                                                    <div className="f-65rem c-black ">
                                                        <span className="f-75rem">Location: </span>
                                                        {
                                                            this.state.selectedVendorLocation
                                                                ?.location_address
                                                        }
                                                    </div>
                                                )}
                                            {!this.state.vendorExpand && this.state.selectedVendorContact && (
                                                <div className="c-black ">
                                                    {
                                                        this.showVendorContactDetail()
                                                    }
                                                </div>
                                            )}
                                        </MDBCol>
                                        <MDBCol md={3} className="mb-2 shipToField">
                                            <div className="f-75rem c-black">
                                                Bill To
                                            </div>
                                            {!this.state.billToExpand && (this.state.selectedBillToVendorLocation?.location_address || this.props?.initialBillToVendor?.[0]?.vendor_locations?.[0]?.location_address) && (
                                                    <div className="c-black f-65rem">
                                                        {/* <span className="f-75rem">Location: </span> */}
                                                        {
                                                            this.state.selectedBillToVendorLocation?.location_address || this.props?.initialBillToVendor?.[0]?.vendor_locations?.[0]?.location_address || null
                                                        }
                                                    </div>
                                                )}
                                                <div className="f-75rem c-black invisibleText"> . </div>
                                                {!this.state.billToExpand && (
                                                    <div className="attnWrapper">
                                                        {/* {
                                                            this.showBillToVendorContactDetail()
                                                        } */}
                                                        <div className="c-black f-75rem">Attn:</div>
                                                        <BasicTextField
                                                            label=""
                                                            value={this.state?.poHeaders?.bill_to_attn || null}
                                                            onChange={(e) => {
                                                                this.onPoHeaderChange(
                                                                    "bill_to_attn",
                                                                    e.target.value === null || e.target.value === ""
                                                                        ? null
                                                                        : e.target.value
                                                                );
                                                            }}
                                                            placeholder="Enter Bill To Attn."
                                                        />
                                                    </div>
                                                )}
                                        </MDBCol>

                                        <MDBCol md={3} className="mb-2 shipToField">
                                            <div className="f-75rem c-black">
                                                Ship To
                                                
                                            </div>
                                            
                                            
                                            {!this.state.shipToExpand && (this.state.selectedShipToVendorLocation?.location_address || this.props?.initialShipToVendor?.[0]?.vendor_locations?.[0]?.location_address) && (
                                                    <div className="c-black f-65rem">
                                                        {/* <span className="f-75rem">Location: </span> */}
                                                        {
                                                            this.state.selectedShipToVendorLocation?.location_address || this.props?.initialShipToVendor?.[0]?.vendor_locations?.[0]?.location_address || null
                                                        }
                                                    </div>
                                                )}
                                                <div className="f-75rem c-black invisibleText"> . </div>

                                            {!this.state.shipToExpand && (
                                                <div className="attnWrapper">
                                                    {/* {
                                                        this.showShipToVendorContactDetail()
                                                    } */}
                                                    <div className="c-black f-75rem">Attn:</div>
                                                    <BasicTextField
                                                        label=""
                                                        value={this.state?.poHeaders?.ship_to_attn || null}
                                                        onChange={(e) => {
                                                            this.onPoHeaderChange(
                                                                "ship_to_attn",
                                                                e.target.value === null || e.target.value === ""
                                                                    ? null
                                                                    : e.target.value
                                                            );
                                                        }}
                                                        placeholder="Enter Ship To Attn."
                                                    />
                                                </div>
                                            )}
                                        </MDBCol>


                                    </MDBRow>


                                    <MDBRow>
                                        <MDBCol md={4} className="mb-2" >
                                            <div className="f-75rem c-black">
                                                Cost Center Number:
                                            </div>
                                            {(!this.state.editPoet1) &&
                                                <MDBRow>
                                                    <MDBCol md={10}>
                                                        <BasicTextField
                                                            label=""
                                                            isMandatory={true}
                                                            value={this.state.poHeaders?.cost_center_no}
                                                            disabled={!this.state.editPoet1}
                                                        />
                                                    </MDBCol>
                                                    < MDBCol md={2} >
                                                        <MDBIcon
                                                            className="cursor-pointer ml2"
                                                            aria-controls="simple-menu"
                                                            aria-haspopup="true"
                                                            color={"primary"}
                                                            fontSize={10}
                                                            onClick={() => this.editPoet(1)}
                                                            icon={"pen"} />
                                                    </MDBCol>
                                                </MDBRow>
                                            }
                                            {
                                                (this.state.editPoet1) &&
                                                <MDBRow>
                                                    <MDBCol md={10}>
                                                        <SelectField
                                                            placeHolderText={"- Select Cost Ceneter -"}
                                                            value={
                                                                this.state.poHeaders?.cost_center_id
                                                            }
                                                            disabled={this.state.poHeaders?.is_void}
                                                            options={
                                                                this.state.costCenterOptions?.map(
                                                                    (item) => ({
                                                                        label: item?.lookup_value,
                                                                        value: item?.lookup_data_id,
                                                                    })
                                                                ) || []
                                                            }
                                                            onChange={(e, value) => this.onPoHeaderChange("cost_center_id", e.target.value)
                                                            }
                                                            isMandatory={true}
                                                            showMandatory={true}
                                                        />
                                                    </MDBCol>
                                                    < MDBCol md={2} className="costCenterIconsWrapper" >
                                                        <MDBIcon
                                                            className="cursor-pointer ml2"
                                                            aria-controls="simple-menu"
                                                            aria-haspopup="true"
                                                            color={"primary"}
                                                            fontSize={10}
                                                            onClick={() => this.editPoet(0)}
                                                            icon={"save"} />
                                                        <MDBIcon
                                                            className="cursor-pointer ml2"
                                                            aria-controls="simple-menu"
                                                            aria-haspopup="true"
                                                            color={"primary"}
                                                            fontSize={10}
                                                            onClick={() => this.clearCostCenterField()}
                                                            icon={"times"} />
                                                    </MDBCol>
                                                </MDBRow>
                                            }
                                        </MDBCol>
                                        < MDBCol md={3} className="mb-2" >
                                            <div className="f-75rem c-black" >
                                                Requested By:
                                            </div>
                                            < MDBRow >
                                                <MDBCol md={12}>
                                                    <SearchSelectField
                                                        className="first"
                                                        detail_selected={
                                                            this.state?.selectedRequestedByUser?.user_id
                                                                ? {
                                                                    value: this.state?.selectedRequestedByUser?.user_id,
                                                                    text: this.state?.selectedRequestedByUser?.user_name,
                                                                }
                                                                : null
                                                        }
                                                        options={
                                                            this.state.requestedByUserList?.map((item) => ({
                                                                text: item.full_name,
                                                                value: item.user_id,
                                                                is_active: item.is_active,
                                                            }))
                                                        }
                                                        loading={this.state.isFetchingUsers}
                                                        width="100%"
                                                        multiple={false}
                                                        searchSelect={true}
                                                        searchText={(event) => { this.searchUsers(event,"requested_by_id") }}
                                                        placeholder="- Type to search User -"
                                                        noOptionsText="No results"
                                                        valueSelected={(e, newValue) => {
                                                            this.onUserSelection(newValue, "requested_by_id");
                                                        }}
                                                    />
                                                </MDBCol>
                                            </MDBRow>

                                        </MDBCol>
                                        < MDBCol md={2} className="mb-2" >
                                            <div className="f-75rem c-black" >
                                                Date Ordered
                                            </div>
                                            <DateField
                                                value={this.state?.poHeaders?.date_ordered ? moment.utc(this.state?.poHeaders?.date_ordered).format('YYYY-MM-DD'):null}
                                                // width={"100%"}
                                                onChange={(e) => {
                                                    this.onPoHeaderChange(
                                                        "date_ordered",
                                                        e.target.value === null || e.target.value === ""
                                                            ? null
                                                            : e.target.value
                                                    );
                                                }}
                                            />
                                        </MDBCol>
                                        < MDBCol md={3} className="mb-2" >
                                            <div className="f-75rem c-black" >
                                                Due Date
                                            </div>
                                            <BasicTextField
                                                label=""
                                                value={this.state?.poHeaders?.due_date || null}
                                                onChange={(e) => {
                                                    this.onPoHeaderChange(
                                                        "due_date",
                                                        e.target.value === null || e.target.value === ""
                                                            ? null
                                                            : e.target.value
                                                    );
                                                }}
                                                placeholder="MM/DD/YYYY"
                                            />
                                        </MDBCol>
                                    </MDBRow>

                                    <MDBRow
                                        className={"mt-3 podetailtable hbopodetailtable tenant3Table"}
                                        id="podetailtable"
                                    >
                                        {this.state.poHeaders?.po_id && (
                                            <MDBCol md={12}>
                                                <TableComponent
                                                    list={this.state?.poLinesList || []}
                                                    config={optionalRightsConfigTenant3}
                                                    isLoading={this.state.isFetchingPOLines}
                                                    tableMode={"light"}
                                                    customNoResultsMessage={"Add a line item"}
                                                    editCallback={this.handleInlineEdits.bind(this)}
                                                    saveCallback={this.saveInlineEdits.bind(this)}
                                                    handleAddNewItem={this.handleAddNewItem.bind(this)}
                                                    addItemToList={!this.state.poHeaders?.is_void}
                                                    handleOnHoverEnter={this.handleOnHoverEnter}
                                                    handleOnHoverLeave={this.handleOnHoverLeave}
                                                    handleDelCallBack={this.handleDelCallBack}
                                                    showMandatory={this.state.postInitiated}
                                                    handleCommentBox={this.handleCommentBox}
                                                    currencies={this.state.currencies}
                                                    showNotesTooltip={true}
                                                    autoCalculate={true}
                                                    handleInlineCopy={this.handleInlineCopy}
                                                    defaultCompanyCurrency={this.state.defaultCompanyCurrency}
                                                    actualCost={this.state.poHeaders?.actual_cost}
                                                    rush={this.state.poHeaders?.rush}
                                                    totalCost={this.state?.poLinesList?.length>0? this.state?.poLinesList?.[0]?.purchase_subtotal_3 || "$0.00": "$0.00"}
                                                    updateRush={this.updateRush}
                                                    className={"fileMakerPoDetails"}
                                                    currencySymbol={"$"}
                                                />
                                                <MDBRow>
                                                    <MDBCol md={6}>
                                                        <div class="float-left voidBtn">
                                                            {this.state.poHeaders?.is_void ? (
                                                                <BasicButton
                                                                    className="mt-2 cancel-void"
                                                                    variant="outlined"
                                                                    text="Cancel Void"
                                                                    onClick={() => this.onVoidClick(0)}
                                                                />
                                                            ) : (
                                                                <BasicButton
                                                                    className="void-btn"
                                                                    variant="outlined"
                                                                    text="Void"
                                                                    onClick={() => this.onVoidClick(1)}
                                                                />
                                                            )}
                                                        </div>
                                                    </MDBCol>

                                                </MDBRow>
                                            </MDBCol>
                                        )}
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md={3} className="mb-3">
                                            <div className="f-75rem c-black">
                                                Issued By
                                            </div>
                                            <SearchSelectField
                                                className="first"
                                                detail_selected={
                                                    this.state?.selectedIssuedByUser?.user_id
                                                        ? {
                                                            value: this.state?.selectedIssuedByUser?.user_id,
                                                            text: this.state?.selectedIssuedByUser?.user_name,
                                                        }
                                                        : null
                                                }
                                                options={this.state.issuedByUserList?.map((item) => ({
                                                    text: item.full_name,
                                                    value: item.user_id,
                                                    is_active: item.is_active,
                                                }))}
                                                loading={this.state.isFetchingUsers}
                                                width="100%"
                                                multiple={false}
                                                searchSelect={true}
                                                searchText={(event) => { this.searchUsers(event,"issued_by_id") }}
                                                placeholder="- Type to search User -"
                                                noOptionsText="No results"
                                                valueSelected={(e, newValue) => {
                                                    this.onUserSelection(newValue, "issued_by_id");
                                                }}
                                            />
                                        </MDBCol>
                                        <MDBCol md={3} className="mb-3">
                                            <div className="f-75rem c-black">
                                                Issue Date
                                            </div>
                                            <DateField
                                                value={this.state?.poHeaders?.issue_date ? moment.utc(this.state?.poHeaders?.issue_date).format('YYYY-MM-DD') : null}
                                                // width={"100%"}
                                                // onChange={(e) => {
                                                //     this.onPoHeaderChange(
                                                //         "issue_date",
                                                //         e.target.value === null || e.target.value === ""
                                                //             ? null
                                                //             : e.target.value
                                                //     );
                                                // }}
                                                disabled={true}
                                            />
                                        </MDBCol>
                                        <MDBCol md={3} className="mb-3">
                                            <div className="f-75rem c-black">
                                                Modified By
                                            </div>
                                            <BasicTextField
                                                label=""
                                                value={this.state?.poHeaders?.modified_by_name}
                                                disabled={true}
                                            />
                                        </MDBCol>
                                        <MDBCol md={3} className="mb-3">
                                            <div className="f-75rem c-black">
                                                Modified Date
                                            </div>
                                            <DateField
                                                value={this.state?.poHeaders?.modified_date ? this.setPSTToLocalDate(this.state?.poHeaders?.modified_date) : null}
                                                // width={"100%"}
                                                onChange={(e) => {
                                                    this.onPoHeaderChange(
                                                        "modified_date",
                                                        e.target.value === null || e.target.value === ""
                                                            ? null
                                                            : e.target.value
                                                    );
                                                }}
                                                disabled={true}
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md={4} className="mb-3">
                                            <div className="f-75rem c-black">
                                                Approval:
                                            </div>
                                            <SearchSelectField
                                                className="first"
                                                detail_selected={
                                                    this.state?.selectedApprovedByUser?.user_id
                                                        ? {
                                                            value: this.state?.selectedApprovedByUser?.user_id,
                                                            text: this.state?.selectedApprovedByUser?.user_name,
                                                        }
                                                        : null
                                                }
                                                options={this.state.approvedByUserList?.map((item) => ({
                                                    text: item.full_name,
                                                    value: item.user_id,
                                                    is_active: item.is_active,
                                                }))}
                                                loading={this.state.isFetchingUsers}
                                                width="100%"
                                                multiple={false}
                                                searchSelect={true}
                                                searchText={(event) => { this.searchUsers(event,"approver_id") }}
                                                placeholder="- Type to search User -"
                                                noOptionsText="No results"
                                                valueSelected={(e, newValue) => {
                                                    this.onUserSelection(newValue, "approver_id");
                                                }}
                                            />
                                        </MDBCol>
                                        <MDBCol md={4} className="mb-3">
                                            <div className="f-75rem c-black">
                                                Dept. Head:
                                            </div>
                                            <SearchSelectField
                                                className="first"
                                                detail_selected={
                                                    this.state?.selectedDeptHeadUser?.user_id
                                                        ? {
                                                            value: this.state?.selectedDeptHeadUser?.user_id,
                                                            text: this.state?.selectedDeptHeadUser?.user_name,
                                                        }
                                                        : null
                                                }
                                                options={this.state.deptHeadUserList?.map((item) => ({
                                                    text: item.full_name,
                                                    value: item.user_id,
                                                    is_active: item.is_active,
                                                }))}
                                                loading={this.state.isFetchingUsers}
                                                width="100%"
                                                multiple={false}
                                                searchSelect={true}
                                                searchText={(event) => { this.searchUsers(event,"department_head_id") }}
                                                placeholder="- Type to search User -"
                                                noOptionsText="No results"
                                                valueSelected={(e, newValue) => {
                                                    this.onUserSelection(newValue, "department_head_id");
                                                }}
                                            />
                                        </MDBCol>
                                        <MDBCol md={4} className="mb-3">
                                            <div className="f-75rem c-black">
                                                Date:
                                            </div>
                                            <DateField
                                                value={this.state?.poHeaders?.date ? moment.utc(this.state?.poHeaders?.date).format('YYYY-MM-DD') : null}
                                                // width={"100%"}
                                                onChange={(e) => {
                                                    this.onPoHeaderChange(
                                                        "date",
                                                        e.target.value === null || e.target.value === ""
                                                            ? null
                                                            : e.target.value
                                                    );
                                                }}
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md={12}>
                                            {!this.state.poHeaders?.is_void && (
                                                <Popover
                                                    anchorOrigin={{
                                                        vertical: "top",
                                                        horizontal: "left",
                                                    }}
                                                    transformOrigin={{
                                                        vertical: "top",
                                                        horizontal: "right",
                                                    }}
                                                    id={"popover"}
                                                    open={this.state.openPopover}
                                                    anchorEl={this.state.anchorEl}
                                                    onClose={this.handleClose}
                                                >
                                                    <MDBRow>
                                                        <MDBCol md={12}>
                                                            <BasicTextArea
                                                                width="300px"
                                                                className="polines-notes"
                                                                rows={3}
                                                                value={
                                                                    this.state.selectedNoteMessage || ""
                                                                }
                                                                onChange={(e) =>
                                                                    this.handleOnNoteChange(
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </MDBCol>
                                                    </MDBRow>
                                                    <MDBRow>
                                                        <MDBCol
                                                            md={12}
                                                            className="d-flex justify-content-end"
                                                        >
                                                            <BasicButton
                                                                text={"Save"}
                                                                className="m-1"
                                                                onClick={() => this.saveNotes()}
                                                            />
                                                            <BasicButton
                                                                variant="outlined"
                                                                type="inline"
                                                                className="m-1"
                                                                text={"Close"}
                                                                onClick={() => this.handleClose()}
                                                            />
                                                        </MDBCol>
                                                    </MDBRow>
                                                </Popover>
                                            )}
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                </MDBRow>
            </>
        );
    }
}

export default withUserContext(PODetails);